(function(){
  function init(root){
    if(root.dataset.kvtInit === '1') return;
    root.dataset.kvtInit = '1';
    var row = root.querySelector('.kvt-row');
    var cards = [].slice.call(root.querySelectorAll('.kvt-c'));

    cards.forEach(function(card){
      var v = card.querySelector('video');
      if(!v) return;
      if(card.dataset.poster){ v.setAttribute('poster', card.dataset.poster); }
      v.removeAttribute('autoplay');
      v.muted = false;
      var btn = card.querySelector('.kvt-play');
      var media = card.querySelector('.kvt-m');
      v.controls = false;
      function start(){
        cards.forEach(function(o){
          var ov = o.querySelector('video');
          if(ov && ov !== v){ ov.pause(); o.classList.remove('playing'); }
        });
        card.classList.add('playing');
        v.controls = true;
        var p = v.play();
        if(p && p.catch){ p.catch(function(){ v.muted = true; v.play(); }); }
      }
      if(btn){ btn.addEventListener('click', start); }
      if(media){ media.addEventListener('click', function(){ if(!card.classList.contains('playing')){ start(); } }); }
      v.addEventListener('play', function(){ card.classList.add('playing'); });
      v.addEventListener('pause', function(){ if(v.currentTime === 0 || v.ended){ card.classList.remove('playing'); } });
      v.addEventListener('ended', function(){ card.classList.remove('playing'); v.controls = false; });
    });

    if('IntersectionObserver' in window){
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(en){
          if(en.intersectionRatio < 0.35){
            var ov = en.target.querySelector('video');
            if(ov && !ov.paused){ ov.pause(); ov.controls = false; en.target.classList.remove('playing'); }
          }
        });
      }, { threshold: [0, 0.35, 1] });
      cards.forEach(function(c){ io.observe(c); });
    }

    function step(dir){
      var c = cards[0];
      var w = c ? c.getBoundingClientRect().width + 16 : 300;
      if(row){ row.scrollBy({ left: dir * w, behavior: 'smooth' }); }
    }
    var prev = root.querySelector('.kvt-prev');
    var next = root.querySelector('.kvt-next');
    if(prev){ prev.addEventListener('click', function(){ step(-1); }); }
    if(next){ next.addEventListener('click', function(){ step(1); }); }
  }

  function boot(){ [].slice.call(document.querySelectorAll('.kvt')).forEach(init); }

  if(document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', function(){ setTimeout(boot, 30); });
})();